import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import GoogleCustomSearch from '../../components/GoogleImageSearch/GoogleCustomSearch';
import SimpleCharts from '../../components/Charts/line_chart';
import chart_data from '../../assets/json/chart_data.json';
import { Container, Grid, Paper, Typography } from '@mui/material';

function SuperAdminDashboard(props) {

  //const {dashboardCharts,chartMetadata} = chart_data;
  const [dashboardCharts, setDashboardCharts] = useState([]);

  useEffect(() => {
    if (!dashboardCharts || dashboardCharts?.length === 0) {
      getDashboardCharts();
    }
  }, [dashboardCharts]);

  const getDashboardCharts = () => {
    const { dashboardCharts, chartMetadata } = chart_data;
    const chartArray = Object.values(dashboardCharts);
    const chartArrayWithKeys = Object.entries(dashboardCharts).map(([key, value]) => ({ key, ...value }));
    //console.log(chartArrayWithKeys);
    setDashboardCharts(chartArrayWithKeys);
  }

  const ChartView = ({ item, index, total }) => {
    return (
        <SimpleCharts chart_data={item} index={index} total={total} />
    );
  }

  const ChartItemView = () => {
    return (
      <div style={styles.gridContainer}>
        {dashboardCharts?.map((item, index) => { return (<ChartView key={index} item={item} index={index} total={dashboardCharts.length} />) })}
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Super Admin Dashboard</h1>
      {/* <p style={styles.subtitle}>Welcome, Super Admin!</p> */}

      <GoogleCustomSearch />

      <ChartItemView />

    </div>
  );
}

// Simple inline styles
const styles = {
  container: {
    padding: '40px',
    textAlign: 'center',
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr", // 2 equal columns
    gap: "16px",
    padding: "16px",
    maxWidth: "100%", // optional: limits width
    margin: "0 auto",   // center the grid
  },
  title: {
    fontSize: '36px',
    marginBottom: '5px',
  },
  subtitle: {
    fontSize: '20px',
    color: 'gray',
    marginBottom: '5px',
  },
  cards: {
    width: '100%',
    display: 'flex',
    justifyContent: 'left',
    gap: '10px',
  },
};

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => ({

});

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = (dispatch) => ({

});

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminDashboard);